import epData from '../assets/episode-data.json';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // skippedEpisodes: epData.map(() => {
    //   return {};
    // }),
    // viewedEpisodes: epData.map(() => {
    //   return {};
    // }),
    epData,
    allEpisodes: epData.reduce((allEps, s) => allEps.concat(s.episodes), [])
  },
  getters: {
    epData: state => state.epData,
    episode: state => (_seasonNumber, _episodeNumber) => {
      const seasonNumber = +_seasonNumber;
      const episodeNumber = +_episodeNumber;

      return state.epData[seasonNumber - 1].episodes[episodeNumber - 1];
    },
    randomEpisode: state => (within, seasonNumber) => {
      const cutoff = Date.now() - (3600 * 1000); // 60 Minutes
      const fullEpisodes = within === 'all' ? state.allEpisodes : state.epData[seasonNumber - 1].episodes;
      let episodes = fullEpisodes.filter(episode =>
        !episode.viewedAt || episode.viewedAt < cutoff
      );

      if (episodes.length === 0) {
        episodes = fullEpisodes;
      }

      const episode = episodes[Math.floor(Math.random() * episodes.length)];

      console.log(episode.episodeName, episode.viewedAt, episode.viewedAt < cutoff);

      return episode;
    },
    season: state => _seasonNumber => {
      const seasonNumber = +_seasonNumber;

      return state.epData[seasonNumber - 1];
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js